import {
  AvailablePaidMembershipPlanGroup
} from '@/models/api/paid-member-price/member-plan/group/available-paid-membership-plan-group'
import { AvailablePaidMemberPlanService } from '@/services/api/paid-member-plan'
import { fromNullable, Option } from 'fp-ts/lib/Option'

export interface ListAvailablePaidMembershipPlanGroupRepository {
  listAvailables(): Promise<AvailablePaidMembershipPlanGroup[]>
}
export interface FindAvailablePaidMembershipPlanGroupRepository {
  findBy(groupId: string): Promise<Option<AvailablePaidMembershipPlanGroup>>
}

type PaidMembershipPlanGroupRepository =
  ListAvailablePaidMembershipPlanGroupRepository
  & FindAvailablePaidMembershipPlanGroupRepository

export class DefaultAvailableMembershipPlanGroupRepository
  implements
    ListAvailablePaidMembershipPlanGroupRepository,
    FindAvailablePaidMembershipPlanGroupRepository {

  static get forHost(): PaidMembershipPlanGroupRepository {
    return new DefaultAvailableMembershipPlanGroupRepository(
      new AvailablePaidMemberPlanService()
    )
  }

  constructor(private readonly planService: AvailablePaidMemberPlanService) {}

  async listAvailables(): Promise<AvailablePaidMembershipPlanGroup[]> {
    const response = await this.planService.groups()

    return response.fold(
      (error) => {
        throw new Error(error.message)
      },
      (groups) => {
        return groups.map(g => new AvailablePaidMembershipPlanGroup(g))
      }
    )
  }

  async findBy(groupId: string): Promise<Option<AvailablePaidMembershipPlanGroup>> {
    // 必要なら、id指定のAPIを追加するかも
    const response = await this.planService.groups()

    return response.fold(
      (error) => {
        throw new Error(error.message)
      },
      groups =>
        fromNullable(groups.map(g => new AvailablePaidMembershipPlanGroup(g)).find(g => g.id === groupId))
    )
  }
}
